module.exports = __webpack_public_path__ + "img/icon_2.2b573b64.svg";